import { render, staticRenderFns } from "./InvitationLp.vue?vue&type=template&id=561ab109&scoped=true"
import script from "./InvitationLp.vue?vue&type=script&lang=js"
export * from "./InvitationLp.vue?vue&type=script&lang=js"
import style0 from "./InvitationLp.vue?vue&type=style&index=0&id=561ab109&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561ab109",
  null
  
)

export default component.exports